import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LocalTransferRequest, TransferDetail } from 'src/app/models/cash-closure.model';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';
import { DateUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ActivatedRoute } from '@angular/router';
import { CompanyService } from 'src/app/services/company.service';
import { HttpErrorResponse } from '@angular/common/http';
import { InvoiceSaleService } from '../../../inventory/sales/invoice-sale/invoice-sale.service';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';

declare let $: any;

@Component({
  selector: 'app-transfer-bank-cash',
  templateUrl: './transfer-bank-cash.component.html',
  styleUrls: ['./transfer-bank-cash.component.scss']
})
export class TransferBankCashComponent {
  cashiers = [];
  banks = [];
  clients = [];
  filterClients = [];
  accountReceivable = [];
  auxDollar: number = 0;
  auxDate = "";
  amountQ: number = 0;
  amountDollar: number = 0;
  request: LocalTransferRequest = new LocalTransferRequest();
  transferDetail: TransferDetail = new TransferDetail();
  contrast = false;
  closed = false;
  user = null;
  buttonSave = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  @ViewChild('file') fileInput: ElementRef;

  constructor(
    private cashService: InvoiceSaleService,
    private accountService: AccountService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private companyService: CompanyService
  ) {
    this.auxDate = new Date().toISOString().split("T")[0];
    this.user = this.authService.getUserPosition();
  }

  ngOnInit(): void {
    var previousList = sessionStorage.getItem('account-receivable-temp');
    if (previousList)
      this.accountReceivable = JSON.parse(previousList);
    var id = this.route.snapshot.paramMap.get('id');
    if (id) {
      if (!isNaN(parseInt(id))) {
        this.companyService.getEventById(parseInt(id)).subscribe({
          next: (response: ResponseObject) => {
            if (response.data.rollbackDate) {
              this.request.rollback = true;
              this.request.date = response.data.rollbackDate;
              this.toastService.info("Se asigna el día del que se hizo el rollback");
            } else {
              this.toastService.error("El evento enviado no es un rollback");
            }
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error("Error al obtener el día al cual corresponde el rollback");
          }
        })
      } else {
        this.toastService.info("La información enviada no es correcta, se muestra un listado de cuentas por cobrar normal");
      }
    }
    this.getCashs();
    this.getBanks();
  }

  getCashs(){
    this.accountService.getCashs().subscribe({
      next: (response: ResponseObject) => {
        this.cashiers = response.data;
        if (this.user) {
          const unique = new Set<number>();
          this.user.forEach((elemento) => {
            unique.add(elemento.cash);
          });
          const filter = Array.from(unique);
          this.cashiers = response.data.filter(cash => filter.includes(cash.id));
        }
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener las cajas, por favor recarga la página");
      }
    });
  }

  getBanks(){
    this.accountService.getAccounts().subscribe({
      next: (response: ResponseObject) => {

        this.banks = response.data;
        if (this.banks.length == 1) {
            this.request.issuerBank = this.banks[0].id;
            this.updateBankAmounts();
          }
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener los bancos, por favor recarga la página");
      }
    });
  }

  updateCashAmounts() {
    const selectedCashier = this.cashiers.find(cashier => cashier.id == this.request.receivingCash);
    if (selectedCashier) {
      this.amountQ = selectedCashier.amount;
      this.amountDollar = selectedCashier.amountForeign;
    } else {
      this.amountQ = 0;
      this.amountDollar = 0;
    }
  }

  updateBankAmounts() {
    const selectedBank = this.banks.find(bank => bank.id == this.request.issuerBank);
    if (selectedBank) {
      console.log("Banco",selectedBank);
      if(selectedBank.currency == 1){
        this.amountDollar = selectedBank.amountForeign;
        this.amountQ = 0;
      }else{
        this.amountQ = selectedBank.balance;
         this.amountDollar = 0;
      }
      
    } else {
      this.amountQ = 0;
      this.amountDollar = 0;
    }
  }

  getTodayDate(): string {
    const months = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];
    const date = new Date();
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} de ${month} de ${year}`;
  }


  deleteClientOfList(index: number) {
    this.accountReceivable.splice(index, 1);
    console.log(this.accountReceivable);

    sessionStorage.setItem('account-receivable-temp', JSON.stringify(this.accountReceivable));
  }

  addClientToAccountList(client: any) {
    var findOut = this.accountReceivable.find((c) => {
      return c.client.nit == client.nit
    });
    if (findOut) {
      this.toastService.info("El cliente ya se encuentra agregado a la lista");
    } else {
      this.accountReceivable.push({ client: client, amount: 0, type_payment: 0 });
      sessionStorage.setItem('account-receivable-temp', JSON.stringify(this.accountReceivable));
    }
  }

  selectImage() {
    $('#file').click();
  }

  changeFile(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      // Convierte la imagen a una URL segura
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.request.image = e.target.result;
        const intensidad = this.calcularIntensidad(e.target.result);
      };

      reader.readAsDataURL(file);
    }
  }

  calcularIntensidad(dataURL: string): number {
    const imagen = new Image();
    imagen.src = dataURL;

    let intensidadPromedio = 0;

    imagen.onload = () => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      if (context) {
        canvas.width = imagen.width;
        canvas.height = imagen.height;
        context.drawImage(imagen, 0, 0, imagen.width, imagen.height);

        const imageData = context.getImageData(0, 0, imagen.width, imagen.height);
        const pixels = imageData.data;
        let sumaIntensidad = 0;

        for (let i = 0; i < pixels.length; i += 4) {
          // Calcula la intensidad promedio (escala de grises)
          sumaIntensidad += (pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3;
        }

        intensidadPromedio = sumaIntensidad / (imagen.width * imagen.height);
        this.contrast = intensidadPromedio > 128;
      }
    };

    return intensidadPromedio;
  }

  save() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    this.request.details = [];
    this.request.from = 1;
    this.request.to = 2;
    this.request.date = DateUtil.parseDateToMilliseconds(this.auxDate);
    var tmp;
    if (this.transferDetail.amount > 0) {
      this.request.exchangeRate = 1.0
      tmp = {
        currency: 0,
        amount: this.transferDetail.amount,
        document: this.request.docNumber,
        externalReference: this.request.issuerBank,
        externalReferenceType: 1
      };
      this.request.details.push(tmp);
    }
    if (this.auxDollar > 0) {
      this.request.exchangeRate = 7.82300;
      tmp = {
        currency: 1,
        amount: this.auxDollar,
        document: this.request.docNumber,
        externalReference: this.request.issuerBank,
        externalReferenceType: 1
      };
      this.request.details.push(tmp);
    }

    this.accountService.saveTransferCashBank(this.request).pipe().subscribe(
      () => {
        this.reset();
        this.buttonSave.loading = false;
        this.toastService.success('El traslado fue realizado con exito');
        this.getCashs();
        this.getBanks();
      },
      (error: any) => {
        this.buttonSave.loading = false;
        this.toastService.error("Error al crear el traslado");
      }
    );

  }

  reset() {
    this.request = new LocalTransferRequest();
    this.transferDetail = new TransferDetail();
    this.auxDollar = 0;
    this.updateBankAmounts();
    this.fileInput.nativeElement.value = '';
  }
}
